import classNames from "classnames";
import AppleLogo from "../../../images/apple-logo.svg?react";
import AuthButton from "../AuthButton";

interface Props {
  children: React.ReactNode;
  className?: string;
  onClick: () => void;
}

export default function AppleButton({ children, className, onClick }: Props) {
  return (
    <AuthButton
      buttonClass={classNames(className)}
      imageClass="apple-logo"
      textClass="apple-text"
      logo={AppleLogo}
      onClick={onClick}
    >
      {children}
    </AuthButton>
  );
}
